export const useDeliveryFeeHandler = (
  setDeliveryFee: React.Dispatch<React.SetStateAction<number>>
) => {
  return (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (value === "") {
      setDeliveryFee(0);
      return;
    }

    const amount = Number(value);

    if (!isNaN(amount) && amount >= 0) {
      setDeliveryFee(amount);
    }
  };
};